// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__bLPk1","content":"GlobalSearch_content__1npyK"};